import { render, staticRenderFns } from "./AtomSpecsList.vue?vue&type=template&id=77ee7500&"
import script from "./AtomSpecsList.vue?vue&type=script&lang=js&"
export * from "./AtomSpecsList.vue?vue&type=script&lang=js&"
import style0 from "./AtomSpecsList.vue?vue&type=style&index=0&id=77ee7500&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports